export interface OutputField {
  transIds: string[];
  // deprecated
  title?: string;
  filterDocument: string;
  fieldTypes: string[];
  fieldGroupType?: string | string[];
  fieldSortedBy: string;
  fieldSortPosition: number;
  fieldPosition: number;
  field: string;
  isRetro?: boolean;
  path?: string[][];
  metadatas: any;
  displayRetro?: boolean;
  displayEntityPath?: boolean;
}

export interface FilterField {
  transIds: string[];
  // deprecated
  title?: string;
  field: string;
  filterDocument: string;
  fieldType: string;
  fieldGroupType?: string | string[];
  fieldPosition?: number;
  filter: any[];
  unitTransId: string;
  metadatas: any;
  path: string[][];
}

export interface ReportTreeValue {
  name: string;
  transIds: string[];
  types: string[];
  groupZoneType?: string | string[];
  unitTransId: string;
  rootKey: string;
  metadatas: any;
  path: string[][];
  isRetro?: boolean;
}

export interface ReportingFields {
  contract: FieldZone[];
  employee: FieldZone[];
  entity: FieldZone[];
  launchOptions?: FieldZone[];
}

export interface FilePositionInTable {
  fileId: string;
  row: number;
  col: number;
}


export interface ReportEntity {
  authorId: number;
  beginDate?: string;
  cliCoreID?: number;
  endDate?: string;
  dateOption?: string;
  filterFields: FilterField[];
  id: number;
  links?: string[];
  outputFields: OutputField[];
  timeFilter?: boolean;
  cliUserIds: number[];
  editingAllowed: boolean;
  isPublic: boolean;
  isStandard: boolean;
  title: string;
  massActionsEnabled: boolean;
  parentValue?: string;
  origin?: 'DYNAMIC_REPORTS' | 'MASS_ACTIONS';
  editable?: boolean;
}

export interface OutputReport {
  authorId: number;
  beginDate: string;
  cliCoreId: number;
  endDate: string;
  dateOption?: string;
  filterFields: { [key: string]: FilterField };
  id: number;
  outputFields: { [key: string]: OutputField };
  timeFilter: boolean;
  editingAllowed: boolean;
  isPublic: boolean;
  isStandard: boolean;
  title: string;
  massActionsEnabled: boolean;
}

export interface MassActionFilterSaveResponse {
  id?: number;
  reportTemplateId?: number;
}

export interface PreviewContractReport {
  reportName?: string;
  cliCoreId: number;
  beginDate: string;
  endDate: string;
  filterDocument: string;
  outputFilters: OutputPreviewField[];
  filterParameters: PreviewFilter[];
}

export interface PreviewSettings {
  type: string;
  previewReport: PreviewContractReport;
}

export interface PreviewFilter {
  filterDocument: string;
  field: string;
  fieldType: string;
  fieldGroupType?: string | string[];
  operatorValueList: any[];
}

export interface OutputPreviewField {
  filterDocument: string;
  fieldTypes: string[];
  fieldGroupType?: string | string[];
  fieldSortedBy: string;
  fieldSortPosition: number;
  fieldPosition: number;
  field: string;
  displayRetro: boolean;
  displayEntityPath: boolean;
  transIds?: string[];
}

export interface Filter {
  sign: FilterSign;
  value: string;
  display: string;
}

export interface PreviewInput {
  result: any[];
  position: any;
  contractIds: number[];
}

export interface FilterItem {
  display: string;
  parentValue: any;
  selectable: boolean;
  value: string;
}

export interface SelectedTreeItem {
  id: string;
  previousId: string;
  text: string;
}

export interface FieldZone {
  metadatas?: any;
  name: string;
  groupName?: string;
  transIds: string[];
  isRetro?: boolean;
  types?: string[];
  groupZoneType?: string | string[];
  path?: string[][];
  rootKey?: string;
  items?: FieldZone[];
}

export interface Sign {
  display: string;
  value: FilterSign;
  text?: string;
}

export interface ReportSelect {
  id: number;
  title: string;
}

export enum FilterSign {
  EQ = 'EQ',
  NE = 'NE',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  EM = 'EM',  // empty
  NEM = 'NEM', // not empty
  BEGINS_WITH = 'BEGINS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
}

export enum FilterSignText {
  EQ = 'COMMON.equals',
  NE = 'COMMON.different',
  GT = 'COMMON.greater_than',
  GTE = 'COMMON.greater_than_or_equal',
  LT = 'COMMON.less_than',
  LTE = 'COMMON.less_than_or_equal',
  EM = 'COMMON.empty',  // empty
  NEM = 'COMMON.not_empty', // not empty
  BEGINS_WITH = 'COMMON.begins_with',
  ENDS_WITH = 'COMMON.ends_with',
  CONTAINS = 'COMMON.contains',
  NOT_CONTAINS = 'COMMON.not_contains',
  EMPTY = 'COMMON.empty',
  NOT_EMPTY = 'COMMON.not_empty'
}

export enum TreeFieldTypes {
  CONTRACT = 'contract',
  EMPLOYEE = 'employee',
  ENTITY = 'entity',
}

export enum ReportTimeDateOption {
  TODAY = 'TODAY',
  LAST_DAY_PREVIOUS_MONTH = 'LAST_DAY_PREVIOUS_MONTH',
  LAST_DAY_PREVIOUS_YEAR = 'LAST_DAY_PREVIOUS_YEAR',
  CURRENT_MONTH = 'CURRENT_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  CURRENT_YEAR = 'CURRENT_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  CUSTOM = 'CUSTOM'
}

export enum ReportTimeDateType {
  SINGLE_DATE = 'SINGLE_DATE',
  BETWEEN_DATES = 'BETWEEN_DATES'
}

export enum ReportCategories {
  MY_REPORTS = 'REPORTS.My_reports',
  SHARED_REPORTS = 'REPORTS.Shared_reports',
  PUBLIC_REPORTS = 'REPORTS.Public_reports',
  STANDARD_REPORTS = 'REPORTS.Standard_reports'
}

export interface DateOptions {
  id: string;
  text?: string;
  beginDate: string;
  endDate: string;
  isDefault?: boolean;
}

export interface CliRegDTO {
  cliCoreId?: number;
  gloRegId?: number;
  id?: number;
  nickName?: string;
  parentCliRegId?: number;
  parentRegIdVisible?: number;
  read?: boolean;
  userSelectable?: boolean;
  userVisible?: boolean;
  write?: boolean;
}

export interface GroupedItem {
  columnName: string;
  value: string;
  count: number;
  rows: Record<string, unknown>[];
  contractIds: number[];
  expanded: boolean;
}

export type NestedHeaderRow = Array<string | { label: string; colspan: number }>;


export interface ColumnConfig {
  data: string;
  type: string;
  readOnly: boolean;
  renderer: (...args: unknown[]) => unknown;
  dateFormat?: string;
  isFile?: boolean;
}
